import React from 'react';
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import { ReactComponent as PencilIcon } from "assets/img/svg/EditGryIcon.svg";
import { ReactComponent as DeleteIcon } from "assets/img/svg/Delete.svg"
import { Card, CardBody, Col, Row } from "reactstrap";
import styles from '../../paymentManagement.module.scss';
import moment from 'moment';

const extractRefundConfigInfo = config => {
  const { branchType = [], businessArea = [], cashierOffices = [], approvalSettingDTO = [], updatedBy, updatedOn } = config;

  let paymodeTypes = [];
  let l1Roles = new Set();
  let l2Roles = new Set();
  let l3Roles = new Set();

  approvalSettingDTO.forEach(el => {
    if (el?.paymodeType) {
      paymodeTypes.push(el.paymodeType);
    }
    el.l1Roles.forEach(role => l1Roles.add(role));
    el.l2Roles.forEach(role => l2Roles.add(role));
    el.l3Roles.forEach(role => l3Roles.add(role));
  })

  return {
    paymodeTypes,
    businessArea: businessArea.filter(ba => ba != null),
    cashierOffices: cashierOffices.filter(c => c != null),
    branchType,
    l1Roles,
    l2Roles,
    l3Roles,
    updatedBy,
    updatedOn
  };
};


const ConfigSummaryCard = ({
  config,
  editConfigHandler,
  deleteConfigHandler,
  isUpdatePermission,
  isDeletePermission
}) => {
  const {
    paymodeTypes,
    businessArea,
    cashierOffices,
    branchType,
    updatedBy,
    updatedOn
  } = extractRefundConfigInfo(config);
  const updatedOnDate = updatedOn ? moment(updatedOn).format('DD/MM/YYYY') : '';
  const updatedOnTime = updatedOn ? moment(updatedOn).format('hh:mm A') : '';
  return (
    <Card className={`${styles.card} ${styles.hoverCard}`}>
      <CardBody className={styles.cardBody}>

        {/* LEFT SECTION */}
        <div>
        <div className={styles.leftGrid}>

          <div className={styles.gridItem}>
            <div className={styles.label}>Branch Type</div>
            {branchType ? branchType?.label : '-'}
          </div>

          <div className={styles.gridItem}>
            <div className={styles.label}>BU</div>
            <MultiSelectCellComponentWithSearch
              data={businessArea}
              title="Business Areas"
            />
          </div>

          <div className={styles.gridItem}>
            <div className={styles.label}>Cashier’s OFC</div>
            <MultiSelectCellComponentWithSearch
              data={cashierOffices}
              title="Cashier's Office"
            />
          </div>

          <div className={styles.gridItem}>
            <div className={styles.label}>Paymode</div>
            <div>
              {paymodeTypes?.length
                ? paymodeTypes.map(p => p.label).join(" | ")
                : "-"}
            </div>
          </div>
        </div>
        <div className='color-grey-50 regular-small mt-2'> Last updated by {updatedBy}  on {updatedOnDate} at {updatedOnTime}</div>
        </div>

        {/* RIGHT SECTION */}
        <div className={styles.actionColumn}>
          {isDeletePermission && (
            <DeleteIcon className={styles.actionIcon} onClick={() => deleteConfigHandler(config?.id)} />
          )}

          {isUpdatePermission && (
            <PencilIcon className={styles.actionIcon} onClick={() => editConfigHandler(config)} />
          )}
        </div>

      </CardBody>
    </Card>
  );
};

export default ConfigSummaryCard;

